import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  gridItem: {
    margin: '5px 15px',
    '@media(max-width: 550px)': {
      margin: '5px 0 0 15px',
    },
  },
  captcha: {
    maxHeight: 40,
    maxWidth: '100%',
    borderRadius: 5,
    marginInlineStart: theme.spacing(0),
    margin: '0 9px 10px!important',
    '@media(max-width: 550px)': {
      marginLeft: '0!important',
    },
  },
  captchaLoading: {
    height: 43,
    width: 160,
    borderRadius: 5,
    transform: 'inherit!important',
    marginInlineStart: theme.spacing(0),
    margin: '15px 9px!important',
    '@media(max-width: 550px)': {
      marginLeft: '0!important',
    },
  },
  iconAction: {
    marginBottom: '8px',
    '& .MuiIconButton-root': {
      width: '40px',
      height: '40px',
      padding: '0',
      borderRadius: '5px',
      margin: '9px 0',
      '& svg': {
        transition: 'transform 0.5s ease!important',
        transform: 'rotate(0deg)!important',
      },
      '&:hover': {
        transition: 'transform 0.5s ease!important',

        '& svg': {
          fill: '#303DBF!important',
          transition: '0.5s ease!important',
          transform: 'rotate(180deg)!important',
        },
      },
    },
  },
}));
